var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"c-spinner",attrs:{"viewBox":_vm.viewBox,"width":_vm.width + 'px',"height":_vm.width + 'px',"role":"img","title":"Loading..."}},[_c('circle',{staticClass:"c-spinner-circle",style:({
      transformOrigin: (_vm.width / 2) + 'px ' + (_vm.width / 2) + 'px 0',
      strokeDasharray: (3.14 * _vm.width) + 'px'
    }),attrs:{"cx":_vm.circlePosition,"cy":_vm.circlePosition,"r":_vm.radius,"stroke-width":_vm.strokeWidthValue}})])}
var staticRenderFns = []

export { render, staticRenderFns }